<template>
    <div id="sig-container" class="full form-horizontal">
        <div class="widget">
            <div class="widget-content widget-content-mini themed-background-dark-default text-light">
                <span class="float-right text-muted">
                    <span class="float-right text-muted">
                        <button @click="$router.go(-1)" class="btn btn-xs btn-primary">Volver</button>
                    </span>
                </span>
                Información de contacto
            </div>
            <div class="widget-content border-bottom themed-background-muted text-center" v-if="Object.keys(deudor).length > 0">
                <div class="row">
                    <label for="" class="col-2 text-right"><strong>Tipo de identificación</strong></label>
                    <div class="col-9 text-left">
                        {{ deudor.tipo_identificacion }}
                    </div>
                </div>
                <div class="row">
                    <label for="" class="col-2 text-right"><strong>Identificación</strong></label>
                    <div class="col-2 text-left">
                        {{ deudor.identificacion }}
                    </div>
                </div>
                <div class="row">
                    <label for="" class="col-2 text-right"><strong>Nombre</strong></label>
                    <div class="col-2 text-left">
                        {{ deudor.nombre }}
                    </div>
                </div>
                <div class="row">
                    <label for="" class="col-2 text-right"><strong>Género</strong></label>
                    <div class="col-2 text-left">
                        {{ deudor.genero }}
                    </div>
                </div>
            </div>
        </div>

        <div class="widget">
            <div class="widget-content widget-content-mini themed-background-dark-default text-light">
                <span class="float-right text-muted">

                </span>
                Detalles de la obligación
            </div>
            <div class="widget-content border-bottom themed-background-muted text-center" v-if="obligacion">
                <div class="row mt-2">
                    <div class="col-md-4 text-right">
                        <strong>Identificador de la Obligación</strong>
                    </div>
                    <div class="col-md-8 text-left">
                        {{ obligacion.identificador_obligacion }}
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-md-4 text-right">
                        <strong>Saldo Capital</strong>
                    </div>
                    <div class="col-md-8 text-left">
                        {{ obligacion.saldo_capital | numberFormat }}
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-md-4 text-right">
                        <strong>Observaciones</strong>
                    </div>
                    <div class="col-md-8 text-left">
                        {{ obligacion.observaciones }}
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-md-4 text-right">
                        <strong>Convenio</strong>
                    </div>
                    <div class="col-md-8 text-left">
                        {{ obligacion.informacion_adicional.convenio }}
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-md-4 text-right">
                        <strong>Fecha de inicio de mora</strong>
                    </div>
                    <div class="col-md-8 text-left">
                        {{ obligacion.informacion_adicional.fecha_inicio_mora }}
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-md-4 text-right">
                        <strong>Intermediario</strong>
                    </div>
                    <div class="col-md-8 text-left">
                        {{ obligacion.informacion_adicional.intermediario }}
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-md-4 text-right">
                        <strong>Producto</strong>
                    </div>
                    <div class="col-md-8 text-left">
                        {{ obligacion.informacion_adicional.producto }}
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-md-4 text-right">
                        <strong>Otros gastos</strong>
                    </div>
                    <div class="col-md-8 text-left">
                        {{ obligacion.informacion_adicional.otros_gastos | numberFormat }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {mapGetters} from 'vuex'

export default {
    name: 'Obligación',
    data: () => {
        return {

        }
    },
    computed: {
        ...mapGetters({'deudor': 'deudor/deudor', 'loading': 'loading', 'obligaciones': 'deudor/obligaciones'}),
        obligacion() {
            const obligacion = this.obligaciones.find(obligacion => obligacion.id == this.$route.params.obligacion_id)
            if (typeof obligacion.informacion_adicional != 'object') {
                obligacion['informacion_adicional'] = JSON.parse(obligacion.informacion_adicional)
            }
            return obligacion;
        }
    },
    mounted() {

    }
}
</script>